import {
    Component
} from '@angular/core';
import {
    OnInit
} from '@angular/core';
import {
    TweenLite,
    TimelineMax
} from 'gsap';
import {
    HttpClient
} from '@angular/common/http';

@Component({
    selector: 'app',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.css'],
    providers: []
})
export class ProfileComponent {
    textAnimation: Object;
    items: Array < Object >
        profileData: Object;

    constructor(public http: HttpClient) {}

    ngOnInit(): void {
        // get data - maybe use a service?
        this.http.get('./assets/configs/profile.json').subscribe(data => {
            this.profileData = data;
        });


        //Timeout is allowing for angular to create the divs from data in the json file
        var that = this;
        setTimeout(() => {
            this.init();
        }, 150);
    }


    loadData() {
        console.log('No Data. Trying again...'); //add in a timeout 
        if (!this.profileData) {
            this.http.get('./assets/configs/profile.json').subscribe(data => {
                this.profileData = data;
            });

            setTimeout(() => {
                this.init();
            }, 350);
        } else this.init();
    }

    init() {
        // if data is not loaded then we cannot construct our view so go back and load data
        if (!this.profileData) {
            this.loadData()
        } else {
            this.bindToElements();
            this.setUpAnimations();
            this.playAnimations();
        }
    }

    /** ***************************** Bind and Setup ***************************************************/

    bindToElements(this) {
        this.createSlideBindings();
        this.homeButton = document.getElementById("home");
        this.replayButton = document.getElementById("replay");
        this.profileContainer = document.getElementById("profile-component-container");
    }

    createSlideBindings(this) {
        // This reads tha amount of items in the json file to determine how many items to map 2 instead of manually having to enter code 
        //this.items1 = document.getElementById("slide-1");
        //this.items2 = document.getElementById("slide-2");
        this.items = [];
        for (var b = 0; b < this.profileData.length; b++) {
            console.log(this.profileData[b].id)
            this.items[b] = document.getElementById(this.profileData[b].id);
        }
    }

    setUpAnimations() {
        this.textAnimation = new TimelineMax({
            repeat: 0
        });
    }

    /** ***************************** Play Animations ***************************************************/

    playAnimations(this) {
        this.x = this.getMiddleX();
        this.textAnimation.to(this.homeButton, 0.5, {
            scale: 1,
            opacity: 1,
            y: 0
        });
        this.playSlideAnimations();
        this.playButtonAnimations();
    }

    playSlideAnimations(this) {
        console.log(this.items.length);
        for (var a = 0; a < this.items.length; a++) {
            this.textAnimation.fromTo(this.items[a], 1, {
                opacity: 0,
                x: 0,
                xPercent: -50
            }, {
                opacity: 1,
                x: this.x,
                xPercent: -50
            });
            this.textAnimation.to(this.items[a], 1, {
                opacity: 0,
                x: window.innerWidth - 150
            }, "+=5");
        }
    }

    playButtonAnimations(this) {
        this.textAnimation.to(this.homeButton, 1, {
            scale: 3,
            opacity: 1,
            y: -(window.innerHeight / 2)
        });
        this.textAnimation.to(this.replayButton, 0.4, {
            scale: 3,
            opacity: 1,
            y: -((window.innerHeight / 2) - 100)
        });
    }

    /** ***************************** Reset Animations ***************************************************/

    resetButtonAnimations(this) {
        this.textAnimation.to(this.homeButton, 0.1, {
            scale: 1,
            y: 0
        });
        this.textAnimation.to(this.replayButton, 0.1, {
            scale: 1,
            opacity: 0,
            y: 0
        });
    }

    resetSlideAnimations(this) {
        for (var a = 0; a < this.items.length; a++) {
            this.textAnimation.to(this.items[a], 0.1, {
                opacity: 0,
                x: 0,
                xPercent: -50
            });
        }
    }

    resetAnimations(this) {
        this.resetButtonAnimations(this);
        this.resetSlideAnimations(this);
    }

    /** ***************************** Reset Animations ***************************************************/

    // Handle Click on replay
    handleReplay(this) {
        this.resetButtonAnimations(this);
        this.playAnimations(this);
    }

    // Handle Window Resize
    handleResize(this) {
        this.textAnimation.totalProgress(1).kill();
        this.resetAnimations();
        this.playAnimations(this);
    }


    // Get the correct X value - like to move this out into a co-ordinate class
    getMiddleX(this) {
        return window.innerWidth / 2;
    }



}


// WEBPACK FOOTER //
// /Users/haydenso/Desktop/Code/Projects/haydensookchand/website_source/src/app/profile/profile.component.ts